import type { ReactNode } from "react";
import css from "./Facts.module.css";

type FactsProps = {
  facts: Fact[];
};

type Fact = {
  name: ReactNode;
  value: ReactNode;
  show?: boolean;
};

export function Facts(props: FactsProps) {
  return (
    <ul className={css.root}>
      {props.facts.map((fact, i) => {
        if (fact.show === false) {
          return null;
        }
        return (
          <li className={css.item} key={i}>
            <span className={css.name}>{fact.name}: </span>{" "}
            <span className={css.value}>{fact.value}</span>
          </li>
        );
      })}
    </ul>
  );
}
